<template>
      <div class="row card">

          <div class="card-header">
            <div class="row">
               <div class="col-md-5">
                  <h3 class="title">{{$t('reports')}} <span style="color: #FDCB6A">|</span> {{ $t('monthly_activations') }}</h3>
               </div>
               <div class="col-md-2">
                 <fg-input>
                    <el-select size="large" @change="getSearchReport" class="select-primary" v-model="form.year" filterable clearable :placeholder="$t('select_year')">
                        <el-button @click="getReportYears" style="width:100%; border:none">{{ $t('all') }}</el-button>
                        <el-option
                          class="select-primary"
                          v-for="year in years"
                          :key="year"
                          :label="year"
                          :value="year"></el-option>
                    </el-select>
                 </fg-input>
               </div>
               <div class="col-md-3">
                 <fg-input>
                    <el-select size="large" @change="getSearchReport" class="select-primary" v-model="form.countryID" filterable clearable :placeholder="$t('select_country')">
                        <el-button @click="getReportCountry" style="width:100%; border:none">{{ $t('all') }}</el-button>
                        <el-option
                          class="select-primary"
                          v-for="country in Countries"
                          :key="country.id"
                          :label="country.name"
                          :value="country.id"></el-option>
                    </el-select>
                 </fg-input>
               </div>
               <div class="col-md-2">
                  <fg-input>
                      <el-select size="large" @change="getSearchReport" class="select-primary" v-model="form.ngoID" value-key="0" filterable clearable :placeholder="$t('select_ngo')">
                          <el-button @click="getReportNGO" style="width:100%; border:none">{{ $t('all') }}</el-button>
                          <el-option
                            class="select-primary"
                            v-for="ngo in NGO"
                            :key="ngo.id"
                            :label="ngo.name"
                            :value="ngo.id"></el-option>
                      </el-select>
                  </fg-input>
               </div>
            </div>
          </div>
          <hr>
          <div class="card-body" v-loading="loading" :element-loading-text="$t('loading_data')+'...'">
              <div class="col-12" v-if="reports.length > 0">
                <chart-card :chart-data="activityChart.data"
                            :chart-height="130"
                            chart-id="activity-bar-chart"
                            chart-type="Bar">
                  <template slot="header">
                    <h4 class="card-title">{{ form.year }} Activations</h4>
                  </template>
                </chart-card>
              </div>
          </div>
      </div>
</template>
<script>
import ChartCard from 'src/components/UIComponents/Cards/ChartCard';

import Resource from "@/util/Api/resource.js";
const NGOResources = new Resource("category/childrenGivenParent");
const Report = new Resource("trainer/report");

export default {
  components: {
    ChartCard,
  },
  data() {
    return {
        search:'',
        loading:false,
        activityChart: {
          data: {
            labels: [],
            datasets: [
              {
                label: this.$t("data"),
                borderColor: '#000000',
                fill: true,
                backgroundColor: '#000000',
                hoverBorderColor: '#FDC353',
                borderWidth: 2,
                data: [],
              },
            ]
          }
        },
        NGO:[],
        Countries:[],
        reports:[],
        years:[],
        form:{
          countryID:'',
          ngoID:'',
          year: new Date().getFullYear(),
        },
        showCountryError:false,
        showNgoError:false,
    }
  },

  methods: {

    // Get all NGOs in a categories
    async getNGOs() {
      await NGOResources.get(1).then(response => {
        this.NGO = response.data;
      }).catch(error => {
         this.showAlertMessage(error.response.data.message, "error");
      });
    },

    // Get all countries in a category
    async getCountry() {
      await NGOResources.get(2).then(response => {
        this.Countries = response.data;
      }).catch(error => {
         this.showAlertMessage(error.response.data.message, "error");
      });
    },

    // Get chart report
    async getReport(){
      this.reports = [];
      this.activityChart.data.labels = [];
      this.activityChart.data.datasets[0].data = [];

      this.loading = true;

      await Report.report(0, 0, 0).then((response) => {
        this.reports = response.data;

        this.reports.forEach((element,index) => {
           this.activityChart.data.labels.push(this.getMonthName(element.month));
           this.activityChart.data.datasets[0].data.push(element.total);
        });

        this.loading = false;

      }).catch((error) => {});
    },

    // Get chart report for all NGO
    async getReportNGO(){
      this.reports = [];
      this.activityChart.data.labels = [];
      this.activityChart.data.datasets[0].data = [];

      this.loading = true;
      this.form.ngoID = 0;

      if(this.form.year === ""){
        this.form.year = 0;
      }

      if(this.form.countryID === ""){
         this.form.countryID = 0;
      }

      await Report.report(this.form.countryID, this.form.ngoID, this.form.year).then((response) => {
        this.reports = response.data;

        this.reports.forEach((element,index) => {
           this.activityChart.data.labels.push(this.getMonthName(element.month));
           this.activityChart.data.datasets[0].data.push(element.total);
        });

        this.loading = false;
      }).catch((error) => {}).finally(() => {

          this.form.ngoID  = "";

          if(this.form.year === 0){
            this.form.year = "";
          }

          if(this.form.countryID === 0){
            this.form.countryID = "";
          }

      });
    },

    // Get chart report for all country
    async getReportCountry(){
      this.reports = [];
      this.activityChart.data.labels = [];
      this.activityChart.data.datasets[0].data = [];

      this.loading = true;

      this.form.countryID = 0;

      if(this.form.year === ""){
        this.form.year = 0;
      }

      if(this.form.ngoID === ""){
         this.form.ngoID = 0;
      }

      await Report.report(this.form.countryID, this.form.ngoID, this.form.year).then((response) => {
        this.reports = response.data;

        this.reports.forEach((element,index) => {
           this.activityChart.data.labels.push(this.getMonthName(element.month));
           this.activityChart.data.datasets[0].data.push(element.total);
        });

        this.loading = false;

      }).catch((error) => {}).finally( () => {

        this.form.countryID  = "";

        if(this.form.year === 0){
          this.form.year = "";
        }

        if(this.form.ngoID === 0){
          this.form.ngoID = "";
        }

      });
    },

    // Get chart report for all years
    async getReportYears(){
      this.loading = true;
      this.reports = [];
      this.activityChart.data.labels = [];
      this.activityChart.data.datasets[0].data = [];

      this.form.year = 0;

      if(this.form.countryID === ""){
        this.form.countryID = 0;
      }

      if(this.form.ngoID === ""){
         this.form.ngoID = 0;
      }

      await Report.report(this.form.countryID, this.form.ngoID, this.form.year).then((response) => {

        this.reports = response.data;

        this.reports.forEach((element,index) => {
           this.activityChart.data.labels.push(this.getMonthName(element.month));
           this.activityChart.data.datasets[0].data.push(element.total);
        });

        this.loading = false;

      }).catch((error) => {}).finally(() => {

        this.form.year = "";

        if(this.form.countryID === 0){
          this.form.countryID = "";
        }

        if(this.form.ngoID === 0){
          this.form.ngoID = "";
        }

      });
    },

    // get specific report
    async getSearchReport(){
      this.reports = [];
      this.activityChart.data.labels = [];
      this.activityChart.data.datasets[0].data = [];

      //this.form.year = new Date().getFullYear();

      this.loading = true;

      if(this.form.ngoID === ""){
        this.form.ngoID = 0;
      }

      if(this.form.countryID === ""){
        this.form.countryID = 0;
      }

      if(this.form.year === "") {
         this.form.year = 0;
      }


      // this.form.year = 0;
      await Report.report(this.form.countryID, this.form.ngoID, this.form.year).then((response) => {

        this.reports = response.data;

        this.reports.forEach((element,index) => {
           this.activityChart.data.labels.push(this.getMonthName(element.month));
           this.activityChart.data.datasets[0].data.push(element.total);
        });

        this.loading = false;

      }).catch((error) => {}).finally(() => {
        if(this.form.ngoID === 0){
          this.form.ngoID = "";
        }

        if(this.form.countryID === 0){
          this.form.countryID = "";
        }

        if(this.form.year === 0) {
          this.form.year = "";
        }

      });
    },

    // get year range
    getYear(){
       let currentYear = new Date().getFullYear();
       let startYear = 2016;
       for(var i=startYear; i <= currentYear; i++){
          this.years.push(startYear++);
       }
       this.years.reverse();
    },

    // get month name
    getMonthName(month){
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return monthNames[month - 1];
    }

  },

  created() {
      this.getNGOs();
      this.getCountry();
      this.getReport();
      this.getYear();
  },

}
</script>
